document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-bm-thumb]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-bm-gallery]');
  if (!gallery) return;

  const mainImg = gallery.querySelector('[data-bm-main-image]');
  const newSrc = thumb.getAttribute('data-full-src');
  if (mainImg && newSrc) {
    mainImg.src = newSrc;
    mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
  }

  gallery.querySelectorAll('[data-bm-thumb]').forEach((t) => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
});
